/**
 * @generated SignedSource<<413764e5c6e21a535c49511d2447ffe3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DemoFunctionalityContextTemplatesAndLocationsQuery$variables = Record<PropertyKey, never>;
export type DemoFunctionalityContextTemplatesAndLocationsQuery$data = {
  readonly locations: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null | undefined;
  } | null | undefined> | null | undefined;
};
export type DemoFunctionalityContextTemplatesAndLocationsQuery = {
  response: DemoFunctionalityContextTemplatesAndLocationsQuery$data;
  variables: DemoFunctionalityContextTemplatesAndLocationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Location",
    "kind": "LinkedField",
    "name": "locations",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DemoFunctionalityContextTemplatesAndLocationsQuery",
    "selections": (v0/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DemoFunctionalityContextTemplatesAndLocationsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b92c47d78eeeca01ccfb823dabe9c764",
    "id": null,
    "metadata": {},
    "name": "DemoFunctionalityContextTemplatesAndLocationsQuery",
    "operationKind": "query",
    "text": "query DemoFunctionalityContextTemplatesAndLocationsQuery {\n  locations {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "7b71d14139ebb6cd2f9641069c565cdf";

export default node;
